var Curriculog = Curriculog || {};

Curriculog.CurriculogModel = (function ($, _, Backbone, CurriculogModel) {

	CurriculogModel = Backbone.Model.extend({
        deepClone: function () {
            return new this.constructor(JSON.parse(JSON.stringify(this.attributes)));
        },

		getSanitizedModel: function () {
			sanitizedModel = this.clone();
			sanitizedModel.set({
				'name': escapeUserInput(sanitizedModel.get('name')),
			});
			return sanitizedModel;
		},

		getSanitizedObject: function () {
			sanitizedModel = this.getSanitizedModel();
			return sanitizedModel.toJSON();
		},

		showGrowl: function (message) {
			$('#growls').notify('create', 'warning-template', {
				text: message
			});
		},

		update: function (updateData) {
			for (var key in this.attributes){
				if (updateData[key] != undefined) {
					this.set(key, updateData[key]);
				}
			}

			this.trigger('change');
		},
	});
	return CurriculogModel;

})($, _, Backbone, Curriculog.CurriculogModel || {});
